import React from 'react';
import { FacebookIcon, InstagramIcon, LinkedinIcon } from 'lucide-react';
const socials = [{
  icon: FacebookIcon,
  label: 'Facebook'
}, {
  icon: InstagramIcon,
  label: 'Instagram'
}, {
  icon: LinkedinIcon,
  label: 'LinkedIn'
}];
export function SiteFooter() {
  return <footer className="w-full bg-navy-950 py-12" data-id="element-143" data-mp="3hig3cbyiemea">
      <div className="mx-auto max-w-7xl px-6 lg:px-8" data-id="element-144" data-mp="3hhojtzi6sf4d">
        <div className="flex flex-col gap-8 border-b border-white/10 pb-8 sm:flex-row sm:items-center sm:justify-between" data-id="element-145" data-mp="3dgl37asbef23">
          <p className="text-sm font-black uppercase tracking-widest text-white" data-id="element-146" data-mp="38hi6cdmhnf57">
            The AI Real Estate Growth System
          </p>
          <ul className="flex items-center gap-3" data-id="element-147" data-mp="33ix468noele4">
            {socials.map(({
            icon: Icon,
            label
          }) => <li key={label} data-id="element-148" data-mp="11rbobx95bi9i">
                <a href="#get-access" aria-label={label} className="inline-flex h-9 w-9 items-center justify-center rounded-lg border border-white/10 text-slate-400 transition-colors duration-150 ease-out hover:border-brand-gold/40 hover:text-brand-gold focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-gold" data-id="element-149" data-mp="11rk0to1cwlk6">
                  <Icon aria-hidden="true" className="h-4 w-4" data-id="element-150" data-mp="vspa6ten5xfm" />
                </a>
              </li>)}
          </ul>
        </div>

        <div className="mt-8 flex flex-col gap-4 text-sm text-slate-500 sm:flex-row sm:items-center sm:justify-between" data-id="element-151" data-mp="10qz6j7c3r42t">
          <p data-id="element-152" data-mp="1ohv3sjzburhg">© {new Date().getFullYear()} The AI Real Estate Growth System. All rights reserved.</p>
          <nav aria-label="Footer" data-id="element-153" data-mp="1tfwlp1l0okrc">
            <ul className="flex flex-wrap items-center gap-x-6 gap-y-2" data-id="element-154" data-mp="1tiaipfz9c71j">
              <li data-id="element-155" data-mp="1er9xeadewinz">
                <a href="#get-access" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-156" data-mp="1eppbf955y81q">
                  Privacy Policy
                </a>
              </li>
              <li data-id="element-157" data-mp="27ewbwdo6h7pm">
                <a href="#get-access" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-158" data-mp="27ee4qlzz992x">
                  Terms of Service
                </a>
              </li>
              <li data-id="element-159" data-mp="2m24o9ht83j36">
                <a href="mailto:support@airealestategrowth.com" className="transition-colors duration-150 ease-out hover:text-white" data-id="element-160" data-mp="2m0jtps6ws05b">
                  aulanova.digital@gmail.com

                </a>
              </li>
            </ul>
          </nav>
        </div>

        <p className="mt-8 max-w-3xl text-xs leading-relaxed text-slate-500" data-id="element-161" data-mp="282mx4vsgftqn">
          This product is educational. Results referenced are not typical and depend on your market, effort and
          implementation. Nothing here is legal advice — confirm all compensation and disclosure practices with your
          broker.
        </p>
      </div>
    </footer>;
}